export default __webpack_public_path__ + "static/media/Willow Seed.c31ee6d8.PNG";